import _default from './Transition';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/semantic-ui-react/dist/es/modules/Transition/index.js
// module id = 833
// module chunks = 0